export const SIDE_CONTENT_DEFAULT_WIDTH = 640;
export const SIDE_CONTENT_MIN_WIDTH = 360;
/**
 * Design cap on the side content panel width, on top of the space the
 * container can spare. The docked host applies it; the overlay drawer omits
 * it and lets the viewport (via the container) bound the panel instead.
 */
export const SIDE_CONTENT_MAX_WIDTH = 1024;
